<template>
    <div class="slider">
        <div
            :ref="sliderRefName"
            :class="{
                slider__conveyor: true,
                swiper: true,
                [this.sliderClass]: true
            }"
        >
            <div class="slider__conveyor__wrapper swiper-wrapper">
                <div v-if="isPreloader" class="slider__conveyor__wrapper__item disabled">
                    <MySkeleton />
                </div>
                <template v-else-if="!isPreloader && slides.length">
                    <!-- ITEM -->
                    <a
                        v-for="(item, idx) in slides"
                        :key="idx"
                        :class="{
                            slider__conveyor__wrapper__item: true,
                            'swiper-slide': true,
                            active: activeSliderItem?.id === item.id
                        }"
                        :data-src="item.img"
                        :data-fancybox="galleryName"
                        @click="setActiveSliderItem(item)"
                    >
                        <img :src="item.img" :alt="'sidebar-item'" />
                    </a>
                </template>
                <div v-else class="slider__conveyor__wrapper__item disabled">
                    <img
                        src="@/themes/novaporta/assets/images/placeholders/product-square-image-not-found.png"
                        alt="product-square-not-found"
                    />
                </div>
            </div>
            <div
                v-show="haveBeenInit && !isPreloader"
                :ref="sliderRefPagination"
                :class="{
                    'swiper-pagination': true,
                    slider__conveyor__pagination: true
                }"
            ></div>

            <div class="slider__conveyor__badges">
                <div v-if="isPreloader" class="slider__conveyor__badges__skeletons">
                    <MySkeleton />
                    <MySkeleton />
                    <MySkeleton />
                </div>
                <Badges v-else :allowFlexWrap="true" :badges="badges" />
            </div>
        </div>
    </div>
</template>

<script>
import { Autoplay, Navigation, Pagination, Swiper, Thumbs } from 'swiper';
import VueTypes, { nullable } from 'vue-types';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import staticId from '~/mixins/static-id';
import { SliderItem } from './../../../../types';
import { BadgeItem } from '~/themes/novaporta/types/badges';

export default {
    name: 'Slider',
    mixins: [staticId],
    props: {
        isPreloader: VueTypes.bool.isRequired,
        slides: VueTypes.arrayOf(SliderItem).def([]),
        badges: VueTypes.arrayOf(BadgeItem).def([])
    },
    data() {
        return {
            activeSliderItem: null,

            isFirstItem: true,
            isLastItem: false,
            haveBeenInit: false,

            galleryName: 'product-mobile-gallery'
        };
    },
    methods: {
        setActiveSliderItem() {
            this.initGallery();
        },

        switchToNextSlide() {
            this.slider.slideNext();
        },
        switchToPrevSlide() {
            this.slider.slidePrev();
        },

        subscribeForUpdatingSwiperData(newSwiper) {
            this.isFirstItem = newSwiper?.isBeginning;
            this.isLastItem = newSwiper?.isEnd;
        },

        initGallery() {
            Fancybox.bind(`[data-fancybox="${this.galleryName}"]`);
        },
        initSwiper() {
            // !!! Use only on client side
            Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

            new Swiper(`.${this.sliderClass}`, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                allowTouchMove: true,
                grabCursor: true,

                pagination: {
                    el: this.$refs[this.sliderRefPagination],
                    type: 'fraction'
                },

                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true
                },

                on: {
                    slideChange: newSwiper => {
                        this.subscribeForUpdatingSwiperData(newSwiper);
                    },
                    init: newSwiper => {
                        this.subscribeForUpdatingSwiperData(newSwiper);
                    }
                }
            });

            this.initGallery();
            this.haveBeenInit = true;
        }
    },
    computed: {
        sliderRefName() {
            return `productSlider${this.idStatic}`;
        },
        sliderRefPagination() {
            return `sliderPagination${this.idStatic}`;
        },
        sliderClass() {
            return `-product-slider-${this.idStatic}`;
        },
        sliderNavPrevClass() {
            return `-product-slider-nav-prev-${this.idStatic}`;
        },
        sliderNavNextClass() {
            return `-product-slider-nav-next-${this.idStatic}`;
        },

        slider() {
            return this.$refs[this.sliderRefName].swiper;
        }
    },
    components: {
        Badges: () => import('@/themes/novaporta/components/reusable/Badges'),

        MySkeleton: () => import('@/themes/novaporta/components/ui/MySkeleton')
    },
    mounted() {
        this.initSwiper();
    }
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
